import { isEqual } from 'lodash';
import { useEffect } from 'react';

import { usePreviousValue } from '@sh4res/bo-common/hooks';

export function useValueChanged<T>(value: T, effect: (value?: T, previous?: T) => void) {
  const previousValue = usePreviousValue(value);

  useEffect(() => {
    if (previousValue !== undefined && !isEqual(previousValue, value)) {
      effect(value, previousValue);
    }
  }, [previousValue, value, effect]);
}
